//
// Group box-like button widget with title.
//
import { useState } from 'react';

import gUtilities from '../script/utilities';

//
// props:
//   string    title      - header
//   string    text       - label to show on button
//   string    width      - one of { small, medium, large, 'Npx' }
//   function  onClick    - function () -> void
//
const ButtonWidget = (props) => {
    const [widgetID] = useState(gUtilities.widgetID());

    function buttonStyle() {
        let px = "200px";

        if (props.hasOwnProperty("width")) {
            if (props.width === "small") {
                px = "120px";
            } else if (props.width === "large") {
                px = "300px";
            } else {
                px = props.width;
            }
        }
        
        let style = {
            width: px
        };

        return style;
    }

    async function onClick() {
        props.onClick();
    }

    return (
        <div className="form-group">
            <label className="col-form-label mt-1" htmlFor={widgetID}>{props.title}</label>
            <div className="input-group mb-1">
                <button className="btn btn-primary" type="button" id={widgetID} onClick={onClick} style={buttonStyle()}>{props.text}</button>
            </div>
        </div>
    );
}

export default ButtonWidget;